import React from "react"
import TextContent from "../TextContent/TextContent"
import ImageWithText from "../ImageWithText/ImageWithText"
import PropTypes from "prop-types"
import * as styles from "./ImageWithTextWrapper-tw-styles"
import { get } from "../../helpers/utils"
import Link from "../UI/Link/Link"

const ImageWithTextWrapper = props => {
  const {
    textContentWrapperCollection,
    imageTextWarpperCollection,
    linkWrapperCollection,
    variant,
  } = props
  const style = styles[variant] || styles.defaultStyle
  const textContentArr =
    textContentWrapperCollection &&
    get(textContentWrapperCollection, "items", [])
  const imageTextArr =
    imageTextWarpperCollection && get(imageTextWarpperCollection, "items", [])
  const linkArr =
    linkWrapperCollection && get(linkWrapperCollection, "items", [])

  return (
    <>
      <div className={style?.NewsDetWrpr}>
        <div className={style?.LeftTextWrap}>
          {textContentArr?.length > 0 &&
            textContentArr.map((item, index) => (
              <TextContent {...item} key={index} />
            ))}
        </div>
        <div className={style?.rightTextWrap}>
          {imageTextArr?.length > 0 &&
            imageTextArr.map((item, index) => (
              <ImageWithText {...item} key={index} />
            ))}
        </div>
      </div>

      {linkArr && (
        <div className={style?.linkContainer}>
          {linkArr.length > 0 && (
            <div className={style?.linkwrap}>
              {linkArr.map((item, index) => (
                <Link
                  ariaLabel={item?.ariaLabel}
                  images={item?.images}
                  url={item?.url}
                  className={style?.linkDown}
                  key={index}
                  target= {item?.target}
                >
                  {item.title}
                </Link>
              ))}
            </div>
          )}
        </div>
      )}
    </>
  )
}

ImageWithTextWrapper.propTypes = {
  textContentWrapperCollection: PropTypes.object,
  imageTextWarpperCollection: PropTypes.object,
  linkWrapperCollection: PropTypes.object,
  variant: PropTypes.string,
}
export default ImageWithTextWrapper
